module.exports = __webpack_public_path__ + "img/Trailblazers Innovate Logo.a03bea8b.png";